"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const likedCounter_1 = require("./front/likedCounter");
const shared_1 = __importDefault(require("./front/shared"));
const share_1 = __importDefault(require("./front/share"));
const LikeModule_1 = __importDefault(require("./front/LikeModule"));
const userStorage_1 = __importDefault(require("./front/storage/userStorage"));
const localStorage_1 = __importDefault(require("./front/storage/localStorage"));
const like_1 = require("./front/like");
const likeInstancesStorage_1 = __importDefault(require("./front/storage/likeInstancesStorage"));
const likedPostsStructurer_1 = __importDefault(require("./front/helpers/likedPostsStructurer"));
const likedPostsApiUrlBuilder_1 = __importDefault(require("./front/helpers/likedPostsApiUrlBuilder"));
document.addEventListener('DOMContentLoaded', () => {
    const localWpApiSettings = wpApiSettings;
    const likeStorage = likedPosts && likedPosts.currentUser !== '0' && likedPosts.likedPostsMeta && localWpApiSettings ?
        new userStorage_1.default(localWpApiSettings, likedPosts.currentUser, likedPosts.likedPostsMeta) :
        new localStorage_1.default(localWpApiSettings, likedPosts.currentBlogId);
    const tooltipLike = likedPosts.tooltipLike;
    const tooltipUnlike = likedPosts.tooltipUnlike;
    (0, likedCounter_1.initializeLikedCounter)(likeStorage);
    (0, like_1.initializeLikeButtons)(likeStorage, new likeInstancesStorage_1.default(), tooltipLike, tooltipUnlike);
    document.querySelectorAll('[data-js-like-posts]').forEach((likePostsContainer) => {
        const postTypesToShow = JSON.parse(likePostsContainer.getAttribute('data-js-like-posts-post-types') || '[]');
        const postAppearance = likePostsContainer.getAttribute('data-js-like-posts-appearance') || 'collection';
        const renderContainer = likePostsContainer.querySelector('[data-js-render-container]');
        const noPostsNotice = likePostsContainer.querySelector('[data-js-no-posts-notice]');
        const preLoaders = likePostsContainer.querySelectorAll('[data-js-like-preloader]');
        const sharedTitle = likePostsContainer.querySelector('[data-js-liked-posts-share-title]');
        const sharedExcerpt = likePostsContainer.querySelector('[data-js-liked-posts-share-excerpt]');
        const shareUrlField = likePostsContainer.querySelector('[data-js-like-share-url]');
        const shareListField = likePostsContainer.querySelector('[data-js-like-share-name]');
        const shareExcerptField = likePostsContainer.querySelector('[data-js-like-share-excerpt]');
        const shareButton = likePostsContainer.querySelector('[data-js-like-share-button]');
        const urlParams = new URLSearchParams(window.location.search);
        const sharedPosts = urlParams.get('liked-posts');
        const likedPostsStructurer = new likedPostsStructurer_1.default();
        const likedPostsApiUrlBuilder = new likedPostsApiUrlBuilder_1.default(wpApiSettings);
        if (postTypesToShow && renderContainer && noPostsNotice && preLoaders) {
            if (sharedPosts) {
                new shared_1.default(renderContainer, urlParams, sharedTitle, sharedExcerpt);
            }
            new LikeModule_1.default(wpApiSettings, likeStorage, sharedPosts, likedPostsStructurer, likedPostsApiUrlBuilder, postTypesToShow, postAppearance, renderContainer, noPostsNotice, preLoaders);
        }
        if (shareButton && shareUrlField && shareListField && shareExcerptField) {
            new share_1.default(likeStorage, postTypesToShow, postAppearance, likedPostsStructurer, likedPostsApiUrlBuilder, shareButton, shareUrlField, shareListField, shareExcerptField);
        }
    });
});
